import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ShowAmbassadorComponent } from 'src/app/shared/components/show-ambassador/show-ambassador.component';
import { Embaixador } from 'src/app/shared/models/dashboard.model';
import { DashboardService } from 'src/app/shared/services/dashboard.service';

@Component({
  selector: 'app-diade-doar-team',
  templateUrl: './diade-doar-team.component.html',
  styleUrls: ['./diade-doar-team.component.scss']
})
export class DiadeDoarTeamComponent {
  ambassadors!: Embaixador[];

  constructor(private dashboardService:DashboardService, public dialog: MatDialog){
    this.dashboardService.dashboard.subscribe(res=>{
      if(res)this.ambassadors = res.time
    })
  }

  openDialog(ambassador: Embaixador){
    this.dialog.open(ShowAmbassadorComponent,
      {
      width: '80vw',
      maxWidth:'100vw',
      data: ambassador,
    });

  }


}
